import { useState, useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import { endpoints } from '../services/api';

export default function Expedientes() {
    const [expedientes, setExpedientes] = useState([]);
    const [tenants, setTenants] = useState([]);
    const [showNew, setShowNew] = useState(false);
    const [newName, setNewName] = useState('');
    const [newCr, setNewCr] = useState('');
    const [createError, setCreateError] = useState('');
    const [mostrarArchivados, setMostrarArchivados] = useState(false);
    const navigate = useNavigate();

    const load = () => {
        endpoints.expedientes.list(mostrarArchivados ? { incluir_archivados: 1 } : {}).then(r => setExpedientes(r.data)).catch(() => {});
    };

    const loadTenants = () => {
        endpoints.expedientes.tenants().then(r => {
            const rows = Array.isArray(r.data) ? r.data : [];
            setTenants(rows);
            setNewCr(current => current || rows[0]?.cr_id || '');
        }).catch(() => {});
    };

    useEffect(load, [mostrarArchivados]);
    useEffect(loadTenants, []);

    const crear = async () => {
        if (!newName.trim()) return;
        if (!newCr) {
            setCreateError('No hay comunidades configuradas');
            return;
        }
        setCreateError('');
        try {
            await endpoints.expedientes.create({ cr_id: newCr, nombre: newName });
            setShowNew(false);
            setNewName('');
            setNewCr(tenants[0]?.cr_id || '');
            load();
        } catch (err) {
            setCreateError(err?.response?.data?.error || 'No se pudo crear el expediente');
        }
    };

    const badgeClass = (estado) => {
        const map = { abierto: 'open', en_proceso: 'progress', completado: 'done', archivado: 'empty' };
        return map[estado] || 'open';
    };

    return (
        <div>
            <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', marginBottom: '24px' }}>
                <h1 style={{ margin: 0 }}>Expedientes</h1>
                <div style={{ display: 'flex', gap: 8 }}>
                    <button className={`btn btn-sm ${mostrarArchivados ? 'btn-secondary' : ''}`}
                        onClick={() => setMostrarArchivados(!mostrarArchivados)}
                        title={mostrarArchivados ? 'Ocultar archivados' : 'Mostrar también archivados'}>
                        📦 {mostrarArchivados ? 'Ocultar archivados' : 'Ver archivados'}
                    </button>
                    <button className="btn btn-primary" onClick={() => setShowNew(true)}
                        title="Crear un nuevo expediente de embargo N63">
                        + Nuevo expediente
                    </button>
                </div>
            </div>

            {showNew && (
                <div className="modal-overlay" onClick={() => setShowNew(false)}>
                    <div className="modal" onClick={e => e.stopPropagation()}>
                        <h2>Nuevo expediente</h2>
                        {createError && (
                            <div className="badge badge-danger" style={{ marginBottom: 16 }}>
                                {createError}
                            </div>
                        )}
                        <div className="form-group">
                            <label>Nombre del expediente</label>
                            <input type="text" value={newName} onChange={e => setNewName(e.target.value)}
                                placeholder="Ej: Embargos marzo 2026" />
                        </div>
                        <div className="form-group">
                            <label>Comunidad de Regantes</label>
                            <select value={newCr} onChange={e => setNewCr(e.target.value)}>
                                {tenants.map(tenant => (
                                    <option key={tenant.cr_id} value={tenant.cr_id}>
                                        {tenant.nombre}
                                    </option>
                                ))}
                            </select>
                        </div>
                        <div style={{ display: 'flex', gap: '8px', justifyContent: 'flex-end' }}>
                            <button className="btn btn-secondary" onClick={() => setShowNew(false)}
                                title="Descartar y volver a la lista">Cancelar</button>
                            <button className="btn btn-primary" onClick={crear}
                                title="Crear el nuevo expediente">Crear</button>
                        </div>
                    </div>
                </div>
            )}

            <div className="card">
                <table className="data-table">
                    <thead>
                        <tr>
                            <th>#</th>
                            <th>Nombre</th>
                            <th>CR</th>
                            <th>Estado</th>
                            <th>Fases</th>
                            <th>Creado</th>
                            <th></th>
                        </tr>
                    </thead>
                    <tbody>
                        {expedientes.map(e => (
                            <tr key={e.id}>
                                <td>{e.id}</td>
                                <td><strong>{e.nombre}</strong></td>
                                <td style={{ fontSize: '0.8rem' }}>{e.cr_id}</td>
                                <td><span className={`badge badge-${badgeClass(e.estado)}`}>{e.estado}</span></td>
                                <td>{e.fases?.length || '-'}</td>
                                <td style={{ fontSize: '0.85rem' }}>{new Date(e.created_at).toLocaleDateString()}</td>
                                <td>
                                    <button className="btn btn-sm btn-secondary"
                                        onClick={() => navigate(`/expedientes/${e.id}`)}
                                        title="Entrar al expediente para gestionar sus fases">
                                        Abrir
                                    </button>
                                </td>
                            </tr>
                        ))}
                        {expedientes.length === 0 && (
                            <tr><td colSpan="7" style={{ textAlign: 'center', padding: '40px', color: 'var(--color-text-muted)' }}>
                                No hay expedientes todavía. ¡Crea el primero!
                            </td></tr>
                        )}
                    </tbody>
                </table>
            </div>
        </div>
    );
}
